import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'
import ApiService from '@/service/api.service'
import Cookies from "js-cookie"
import { v4 as uuidv4 } from 'uuid'

Vue.use(Vuex)
// create a deep clone of the questions to be used to 'reset' the questionaire
export default new Vuex.Store({
    state: {
        questions: null,
        questionOptions: null,
        count: {
            correct: null,
            total: null
        },
        pwa: {
            type: null,
            message: null
        },
        currentQuestion: 0,
        surveyCompleted: false,
        status: {
            message: null,
            code: null
        },
        token: localStorage.getItem('user') || '',
        locations: null,
        smokerType: 0,
        rev: process.env.VUE_APP_REV ? process.env.VUE_APP_REV : '2.4',
        uuid: null
    },
    mutations: {
        
        setPwa: (state, payload) => state.pwa = payload,
        updateQuestion: (state, payload) => {
            
            const question = state.questions.find(item => item.id === payload.id);
            question.selected = payload.finalAnswer.ids;

            // Map question_options array
            const questionOpt = question.question_options.map((item) => {
                return {
                    qAnswer: item.answerText,
                    qCorrect: item.correct,
                    qAnswerId: item.id,
                };
            });

            // Sum into a scoring the correct answers
            let correctAnswerTotal = 0;
            questionOpt.forEach(function (arrayItem) {
                let x = arrayItem.qCorrect;
                correctAnswerTotal += x;
            });

            // Increment scoring counter if answer is correct based on question scoring
            // console.log(payload);
            // console.log(correctAnswerTotal);
            if (payload.finalAnswer.score === correctAnswerTotal && payload.finalAnswer.wrong === false) {
                state.count.correct++
                question.correctAnswer = true;
                // console.log('correct')
                
            }
            // console.log(state.count.correct, 'state correct answers');
        },
        
        updateSmokerType: (state, payload) => {
            state.smokerType = payload.smokerType;
        },
        
        goToNextQuestion: (state) => {
            const questionLength = state.questions.length - 1;
            if ( questionLength > state.currentQuestion) {
                state.currentQuestion++
            } else {
                state.surveyCompleted = true
            }
        },
        resetQuestions: (state) => {
            // Reset values for correct answers, go to the first question and mark the survey as not completed
            state.surveyCompleted = false
            state.count.correct = null
            state.currentQuestion = 0
            state.smokerType = 0
            state.questions.forEach(question => {
                question.selected = null,
                // 
                question.correctAnswer = false
                // 
            });
            
            router.push({
                name: "Instructions"
            })
        },   
        setLocations: (state, locations) => {
            state.locations = locations
        },
        setQuestions: (state, questions) => {
            // state.questions = questions    //Update for only 1 question
            state.questions = questions.slice(0,1) //show only 2nd question
            state.count.total = questions.length
        },
        setUser: (state, response) => {
            if ( response.status == '401' ) {
                state.status.message = response.data.message
                state.status.code = response.status
                localStorage.removeItem('user')
            } else {
                state.status.message = response.message
                state.token = response.token
                localStorage.setItem('user', state.token)
                Cookies.set('u_log', '1', { expires: 3650 }) //10 hours
                
                router.push({
                    // name: 'Instructions'
                    name: 'ActivationEnded'
                })
            }
        },
        resetPromise: (state) => {
            state.token = ''
            state.status.message = null
            state.status.code = null
            localStorage.removeItem('user')
        },
        changeSurveyCompleted: (state, payload) => {
            state.surveyCompleted = payload
        },
        generateNewUuid: (state) => {
            state.uuid = uuidv4()
        }
    },
    actions: {
        getQuestions: ({ commit }) => {
            return ApiService.customRequest({
                method: 'GET',
                url: 'questions'
            })
            .then((response) => {
                var questions = response.data;
                    questions.forEach(question => {
                        question.selected = null,
                        // 
                        question.correctAnswer = false
                        // 
                    });
                commit('setQuestions', questions)
            })
            .catch(() => {})
        },
        saveQuestion: ({ commit }, payload) => {
            commit('updateQuestion', payload)
        },
        saveSmokerType: ({ commit }, payload) => {
            commit('updateSmokerType', payload)
        },
        nextQuestion: ({ commit }) => {
            commit('goToNextQuestion')
        },
        surveyCompleted: ({ commit, state }) => {
            if(!state.surveyCompleted) {
                commit('changeSurveyCompleted', true);

                const answersNew = [];
                const smokerType = state.smokerType;
                // Added REV for validating with the api
                // const rev = '2.2';
                const rev = state.rev;
                const uuid = state.uuid;

                state.questions.forEach((item) => {
                    item.selected.forEach((answeIitem) => {
                        answersNew.push({
                            questionId: item.id,
                            answer: answeIitem
                        })
                    });
                });
                
                return ApiService.customRequest({
                    headers: {
                        'Authorization': `Bearer ${state.token}` 
                    },
                    method: 'POST',
                    url: 'entries',
                    data: {
                        uniqueId: uuid,
                        answers: answersNew,
                        smokerType: smokerType,
                        rev: rev,
                    }
                })
                .then(() => {
                    // Change route to "Success" to redirect to last screen
                    router.push({ name: "Instructions" }, () => {
                        // commit('resetQuestions');
                        state.surveyCompleted = false
                        state.count.correct = null
                        state.currentQuestion = 0
                        state.smokerType = 0
                        state.questions.forEach(question => {
                            question.selected = null,
                            // 
                            question.correctAnswer = false
                            // 
                        });
                        commit('generateNewUuid');
                        commit('changeSurveyCompleted', false);
                    });

                })
                .catch((error) => {
                    commit('resetPromise');
                    if(typeof(error.response.data.message) != 'undefined' && error.response.data.message == 'Folosesti o versiune veche a aplicatiei. Te rugam sa actualizezi.') {
                        alert('Folosești o versiune veche a aplicației. Te rugăm să actualizezi sau să reîmprospătezi browserul.');
                    }
                    else if(error.response.data.message == 'Error saving entry') {
                        // nu faci nimic
                    }
                })
            }
        },
        resetQuestionsAction: ({ commit }) => {
            commit('resetQuestions');
            commit('generateNewUuid');
        },
        generateNewUuid: ({ commit }) => {
            commit('generateNewUuid');
        },
        checkLogin: ({ commit }, payload) => {
            return ApiService.customRequest({
                method: 'POST',
                url: 'auth/login',
                data: {
                    username: payload.username,
                    password: payload.password,
                    rev: process.env.VUE_APP_REV ? process.env.VUE_APP_REV : '2.4',
                }
            })
            .then((response) => {
                commit('setUser', response.data)
            })
            .catch((error) => {
                if (error.response) {
                    commit('setUser', error.response)
                }
            })
        },
        getLocations: ({ commit }) => {
            return ApiService.customRequest({
                method: 'GET',
                url: 'locations'
            })
            .then((response) => {
                commit('setLocations', response.data)
            })
            .catch(() => {})
        },
        Authenticated: () => {
            router.push({
                // name: "Instructions"
                name: "ActivationEnded"
            })
        },
        resetPromiseAction: ({ commit }) => {
            commit('resetPromise');
            router.push({
                name: "Login"
            })
        }
    },
    getters: {
        allQuestions: (state) => state.questions,
        currentQuestion: (state) => state.currentQuestion,
        checkSurvey: (state) => state.surveyCompleted,
        pwa: (state) => state.pwa,
        count: (state) => state.count,
        dropDownLocations: (state) => state.locations,
        loginMessage: ( state ) => state.status.message,
        isAuthenticated: (state) => !!state.token
    }
})